import { Box } from 'modules/Box';
import { Typography } from 'modules/Typography';
import { LabelContainer } from './styled';
export function MenuLabel(props) {
    const { children, action, sticky } = props;
    return (<LabelContainer $sticky={sticky}>
      <Typography $appearance="100" $fontSize="small">
        {children}
      </Typography>
      {action && <Box ml="auto">{action}</Box>}
    </LabelContainer>);
}
